import { render } from "./ModerationResultForm.vue?vue&type=template&id=61f1a8f9&scoped=true"
import script from "./ModerationResultForm.vue?vue&type=script&lang=js"
export * from "./ModerationResultForm.vue?vue&type=script&lang=js"

import "./ModerationResultForm.vue?vue&type=style&index=0&id=61f1a8f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f1a8f9"]])

export default __exports__